import {transformImage} from "../../../utils/StoryblokService";
import {IStoryblokImage} from "../../../types/IStoryblokImage";
import React, { useState} from "react";
import BackgroundPattern from "../../internal/BackgroundPattern";
import Lightbox from "../../gallery/Lightbox";

interface IProps {
    screenshot: IStoryblokImage,
    projectTitle: string
}

const LightboxScreenshot: React.FC<IProps> = ({screenshot, projectTitle}) => {
    const [isShowing, setIsShowing] = useState(false);

    return <React.Fragment>
        <Lightbox isShowing={isShowing}
        onClose={() => setIsShowing(false)}
            >
            <img
                src={transformImage(screenshot.filename, "/fit-in/1920x1080/filters:fill(transparent):format(png)")}
                className={"w-full "}
                alt={screenshot.title}
                onClick={() => setIsShowing(true)}
            />

        </Lightbox>

        <div
            className="absolute top-0 right-0 -mt-20 -mr-20 lg:top-auto lg:right-auto lg:bottom-1/2 lg:left-1/2 lg:mt-0 lg:mr-0 xl:top-0 xl:right-0 xl:-mt-20 xl:-mr-20"

        >
            <BackgroundPattern/>
        </div>
        {screenshot &&
            <blockquote className="relative rounded-lg bg-white shadow-lg" data-aos={'fade-in'}>
                <div className="rounded-t-lg px-1 py-8 sm:px-2 sm:pt-2 sm:pb-2">
                    <div className="relative text-lg font-medium text-gray-700">
                        <img
                            src={transformImage(screenshot.filename, "0x800")}
                            className={"w-full object-contain aspect-[3/2] cursor-pointer"}
                            alt={screenshot.title}
                            title={screenshot.title}
                            onClick={() => setIsShowing(true)}
                        />

                    </div>
                </div>
                {screenshot &&
                    <cite
                        className="relative flex items-center rounded-b-lg bg-primary py-5 px-6 not-italic sm:items-start sm:py-2 sm:px-4">
                                    <span
                                        className="relative ml-4 font-semibold leading-6">
                  <span className="font-semibold text-white sm:inline">
                      {screenshot.name || projectTitle}
                  </span>{' '}
                </span>
                    </cite>}
            </blockquote>}
    </React.Fragment>
}

export default LightboxScreenshot;